import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { BaseService } from "src/app/shared/services/base.service";
import * as config from "src/app/shared/config/app.config";

@Injectable({
  providedIn: 'root'
})
export class CustomCollaborationService {

  public collaborationDetails = new BehaviorSubject<any>(false);
  collaborationDetails$ = this.collaborationDetails.asObservable();

  constructor(private readonly baseService: BaseService) { }

  getCollaborationDetails(fileType) {
    this.collaborationDetails.next(false);
    this.baseService.get(`${config.RESOURCES}?fields=DEFAULT&fileType=${fileType}`).subscribe((resp) => {
      if (resp !== null && resp !== undefined) {
        this.collaborationDetails.next(resp);
      }
    });
  }

} 
